<script>
  import Slick from 'vue-slick'
  import 'slick-carousel/slick/slick.css'
  import CourseItem from "@components/List/CourseItem";
  import DialogLogin from '@components/Dialog/Login';
  import { authComputed } from '@store/helpers'

  export default {
    components: {
      Slick,
      CourseItem,
      DialogLogin
    },
    props: {
      courseList: {
        type: Array,
        default: () => {
          return []
        },
      },
      type: {
        type: String,
        default: 'grid',
        validator(value) {
          return [
            'grid',
            'flat',
            'isSwiper',
          ].includes(value)
        },
      },
    },
    data() {
      const DEFAULT_PAGE_COUNT = 1;

      return {
        pageCount: DEFAULT_PAGE_COUNT,
        slickOptions: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          initialSlide: DEFAULT_PAGE_COUNT - 1,
          arrows: true,
          centerPadding: '1rem',
          touchThreshold: 3,
          dots: true,
          responsive: [
            {
              breakpoint: 1300,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false
              }
            },
          ]
        },
        isInit: false,
        isDialogLoginVisible: false,
        callbackLogin: () => {
        },
      }
    },
    computed: {
      ...authComputed,
    },
    methods: {
      updateCarousel() {
        if(!this.isInit) {
          this.isInit = true;
          this.$refs.slick.reSlick()
        }
      },
      onSlideTo(index) {
        this.$refs.slick.goTo(index - 1)
      },
      onNext() {
        this.$refs.slick.next()
      },
      onPrev() {
        this.$refs.slick.prev()
      },
      onBeforeChange(event, slick, currentSlide, nextSlide) {
        this.pageCount = nextSlide + 1
      },
      /* onApply(item) {
       this.$route.params.pageType = item.to.params.pageType;
       this.$route.params.breadcrumbTitle = item.title;
       if(this.loggedIn) {
       this.$router.push({ name: 'event-apply'})
       }else {
       this.callbackLogin = () => {
       this.$nextTick(() => {
       this.$router.push({ name: 'event-apply'})
       })
       };

       this.isDialogLoginVisible = true;
       }
       } */
    },
  }
</script>
<template>
  <div :class="$style.listCourse">
    <template v-if="type === 'grid'">
      <div class="row listCourse__gridList">
        <div
          v-for="(courseItem, index) in courseList"
          :key="index"
          class="col-12 col-md-6 col-xl-4 listCourse__gridList__item mb-5"
        >
          <CourseItem
            :course-item="courseItem"
            :type="type"
          />
        </div>
      </div>
    </template>
    <template v-if="type === 'isSwiper'">
      <div class="listCourse__carouselBox">
        <Slick
          ref="slick"
          :options="slickOptions"
          class="listCourse__carouselList slick isStyleBase"
          @beforeChange="onBeforeChange"
        >
          <div
            v-for="(courseItem, index) in courseList"
            :key="`carouseItem-${index}`"
            class="listCourse__carouselList__item"
          >
            <CourseItem
              :course-item="courseItem"
              :type="type"
            />
          </div>
        </Slick>
      </div>
    </template>
    <template v-if="type === 'flat'">
      <div v-for="(item, index) in list" :key="index" :class="$style.coursesItem" class="mb-4 isFlat ">
        <div class="row mx-auto">
          <div class="col-sm-8 col-12">
            <div class="coursesItem__content">
              <h5 class="text-small"> {{ item.date }} </h5>
              <div class="text-xl mt-2">
                <span
                  v-if="item.isLive"
                  class="isLive mr-2 align-middle"
                >
                  LIVE
                </span>
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="col-lg-2 align-self-center order-lg-0 order-first mb-lg-0 mb-2">
            <span class="color-white py-2 px-4 badge"> 審核中 </span>
          </div>
          <div class="col-lg-2 col-sm-4 text-center">
            <div class="coursesItem__action">
              <img src="@src/assets/images/logo/logo.svg" alt=""/>
            </div>
          </div>
        </div>
        <router-link
          class="flat-link"
          :to="{
            name: 'member-event-item',
            params: {
              orderAlias: item.to.params.pageType,
              list: item,
            },
          }"
        >
        </router-link>
      </div>
    </template>
    <DialogLogin
      :visible.sync="isDialogLoginVisible"
      @login="callbackLogin"
    />
  </div>
</template>
<style lang="scss" module>
  .listCourse {
    :global {
      .listCourse {
        &__carouselBox {
          position: relative;
          margin-right: -2rem;
          margin-bottom: -6rem;
          margin-left: -2rem;

          @include max-xl {
            margin-right: 0;
            margin-left: 0;
          }
        }

        &__gridList {
          @include max-md {
            margin-right: -0.5rem;
            margin-left: -0.5rem
          }

          &__item {
            @include max-md {
              padding-right: 0.5rem;
              padding-left: 0.5rem;
            }
          }
        }

        &__carouselList {
          &__item {

          }
        }

        &__gridBox {

        }
      }

      .slick {
        &.isStyleBase {
          .slick-arrow {
            height: calc(100% - 192px);
            margin-top: -96px;
          }
        }
      }
    }
  }

  .coursesItem {
    position: relative;
    padding: 40px 31px;
    overflow: hidden;
    background-color: #FFF;
    // margin: 0.5rem;
    @include max-md {
      padding: 20px;
      // padding: 6rem 1rem 2rem;
    }

    :global {
      .badge {
        background: #F09B0E;
        border: 0;

        @include max-md {
          margin-bottom: 1rem;
        }
      }

      .text-small {
        margin-bottom: 0.8rem;
      }

      .coursesItem {
        &__title {
          font-size: 1.5rem;
          line-height: 1.6;
          // height: 166px;
          @include line-clamp(2, 2.91em); // margin-bottom: 4rem;

          @include max-lg {
            font-size: 1rem;

            @include line-clamp(3, 4.5em); // margin-bottom: 4rem;
          }
        }

        &__action {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 4rem;

          @include max-lg {
            margin-top: 2rem;
          }

          @include max-md {
            flex-direction: column;
          }

          img {
            width: 40%;
            margin-right: 5%;
            // min-width: 137px;
            @include max-md {
              width: 80%;
              margin-bottom: 1rem;
            }
          }
        }

        &__btn {
          z-index: 1;

          @include max-md {
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
            font-size: 0.875rem;
          }
        }
      }

      .flat-link {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
    }

    &:global {
      &.isFlat {
        position: relative;
        display: flex;
        align-items: center;

        &:hover {
          .coursesItem__title {
            color: $color-primary;
          }
        }

        .flat-link {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }

        // justify-content: space-between;
        .row {
          align-items: center;
          width: 100%;
        }

        .coursesItem__action {
          margin-top: 0;
        }

        .coursesItem__title {
          height: auto;
          margin-bottom: 0;
          font-size: 1.25rem;
        }

        .text-small {
          margin-bottom: .5rem;
          font-size: 1rem;
        }

        .badge-outline {
          margin-bottom: 0;
        }

        .coursesItem__action {
          img {
            width: auto;
            max-width: 135px;

            @include max-lg {
              max-width: 300px;
            }
          }

        }
      }
    }
  }

  .courseBox {
    :global {

      .slick {
        &.isStyleBase {
          .slick-arrow {
            height: calc(100% - 192px);
            margin-top: -96px;
          }
        }
      }

    }
  }

  .navigation {
    position: absolute;
    top: 0;
    right: -4rem;
    left: -4rem;
    height: 100%;
    margin-top: -3rem;
    pointer-events: none;

    :global {
      .navigation {
        &__btn {
          position: absolute;
          top: 50%;
          z-index: 0;
          display: flex;
          width: 6rem;
          height: 100%;
          pointer-events: auto;
          background: transparent;
          border: unset;
          transform: translateY(-50%);
          appearance: none;

          &:focus {
            outline: none;
          }

          &:hover {
            .navigation {
              &__icon {
                // color: $color-primary;
                // border-color: $color-primary;
                color: #FFF;
                background: #8C97AB;
              }
            }
          }

          &:active {
            outline: none;

            .navigation {
              &__icon {
                // color: darken($color-primary, 10%);
                // border-color: darken($color-primary, 10%);
                color: #FFF;
                background: darken(#8C97AB, 10%);
              }
            }
          }
        }

        &__prev {
          left: 0;
          align-items: center;
          justify-content: flex-start;
        }

        &__next {
          right: 0;
          align-items: center;
          justify-content: flex-end;
        }

        &__icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 53px;
          height: 53px;
          color: #8C97AB;
          border: unset;
          border: 1px solid #8C97AB;
          border-radius: 100%;
          box-shadow: 0 32px 84px #0E567C2A;
          transition: background 0.3s;
        }
      }
    }
  }
</style>
